<script setup lang="ts">
import { RouterView } from 'vue-router'

import { AppNetworkBanner, AppToast } from '@/shared/ui'
import { useAccent } from '@/shared/composables/useAccent'
import { useTheme } from '@/shared/composables/useTheme'
import AppErrorBoundary from './AppErrorBoundary.vue'

// Bootstrap the accent + theme at the root so the stored choices are
// applied and kept in sync app-wide (pickers in UserMenu share state
// via the composables' module-level refs).
useAccent()
useTheme()
</script>

<template>
  <!-- Boundary wraps the routed views so a render crash shows a
       recoverable fallback, not a blank screen. AppToast stays
       outside it so notifications survive a view crash. -->
  <AppErrorBoundary>
    <RouterView />
  </AppErrorBoundary>
  <!-- Connectivity/slow banner and toasts live outside the boundary so
       they keep working even if a routed view crashes. -->
  <AppNetworkBanner />
  <AppToast />
</template>
